/**
 * Identity properties that every PostHog survey event (`survey shown` /
 * `survey sent` / `survey dismissed`) must carry.
 *
 * `$survey_iteration` is not decorative. posthog-js intercepts these three
 * event names and derives the person properties that gate re-display —
 * `$survey_dismissed/<id>` when no iteration is supplied,
 * `$survey_dismissed/<id>/<iteration>` when one is. A recurring survey (e.g.
 * NPS, which runs on a yearly iteration) has its internal targeting flag
 * written against the *suffixed* key, so omitting the iteration writes a
 * property nothing reads: the flag stays true and the survey re-appears on
 * every session forever, however many times the user dismisses it. The same
 * value also keys the `seenSurvey_<id>_<iteration>` localStorage entry that
 * `getActiveMatchingSurveys` checks client-side.
 */
export const surveyEventProperties = (
  surveyId: string,
  surveyIteration: number | null,
) => ({
  $survey_id: surveyId,
  $survey_iteration: surveyIteration,
});
